import * as React from 'react'

import Trash from '@/assets/icons_new/DeleteColor.svg'
import PrintColor from '@/assets/icons_new/PrintColor.svg'
import TableActionBar from '@/modules/drivers/shared/tableItems/TableActionBar'
import { TableActionButtonInterface } from '@/modules/drivers/types'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import AttestationsService from '@/modules/drivers/services/AttestationsService'
import { useAttestationsDownload } from './useAttestationsDownload'

type Props = {
  companyId: string
  attestationIds: (string | number)[]
  onAfterDelete?: () => Promise<void> | void
}

const AttestationsActions: React.FC<Props> = ({
  companyId,
  attestationIds,
  onAfterDelete,
}) => {
  const { t, tSafe } = useLocalize()
  const { deleteAttestations } = AttestationsService()
  const { downloadSelected } = useAttestationsDownload(companyId)

  const resolveIds = (): number[] =>
    attestationIds
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id))

  const handleDelete = async () => {
    const ids = resolveIds()
    if (ids.length === 0) return
    try {
      await deleteAttestations({ attestationIds: ids, companyId })
      await onAfterDelete?.()
    } catch (e) {
      console.error('Error deleting attestation', e)
    }
  }

  const handleDownload = async () => {
    await downloadSelected(attestationIds)
  }

  const actions: TableActionButtonInterface[] = [
    {
      icon: PrintColor,
      action: handleDownload,
      tooltip: tSafe('attestation.download', 'Pobierz zaświadczenie'),
    },
    {
      icon: Trash,
      action: handleDelete,
      tooltip: t('common.delete'),
    },
  ]

  return <TableActionBar actions={actions} />
}

export default AttestationsActions
